import PropTypes from 'prop-types';
import React from 'react';
import { PATCH } from 'utils/httpMethods';
import { Layout } from 'components/layouts';
import { v4 as uuidv4 } from 'uuid';
import Form from './Form';
import useRouter from '../../../useRouter';

const handleSubmit = async ({ id, ...body }) => {
    const res = await PATCH(`/api/users/${id}`, { body });

    return res.json();
};

const Create = () => {
    const { navigate } = useRouter();

    return (
        <Layout hasFooter>
            <Form
                onSubmit={handleSubmit}
                onSubmitSuccess={({ id }) => navigate(`/admin/user/${id}`)}
                initialValues={{
                    id: uuidv4(),
                    status: 'cgp',
                    isAdmin: false,
                    payingUser: true,
                    needApprovalOnSimulations: true,
                    needApprovalOnCIFDocument: true,
                    hasSimulationsImmoAccess: false,
                    hasSimulationsSCPIAccess: false,
                }}
            />
        </Layout>
    );
};
Create.propTypes = {
    navigate: PropTypes.shape({}),
};

export default Create;
